export enum EmailValidatorResult {
  InvalidEmailFormat,
  UserDoesNotExist,
  UmbracoUserExists,
  MigrationUserExists,
}

export type CustomerNumberValidatorResult = {
  success: boolean;
  name: string;
};

export type RegisterAccountType = "private" | "business";

export type RegisterAccountPrivate = {
  type: "private";
  name: string;
  email: string;
  phoneNumber: string;
  password: string;
  password2: string;
  customerAddress: string;
  customerAddress2: string;
  customerPostalCode: string;
  customerCity: string;
};

export type RegisterAccountBusiness = {
  type: "business";
  name: string;
  email: string;
  phoneNumber: string;
  password: string;
  password2: string;
  customerNumber: string;
  customerName: string;
  customerAddress: string;
  customerAddress2: string;
  customerPostalCode: string;
  customerCity: string;
  customerPhoneNumber: string;
  customerEmail: string;
  customerCVR: string;
  customerEAN: string;
};
